import React from 'react'
import './CallToAction.scss'
import '../../../scss/style.scss'
import RegisterButton from '../../CTA/RegisterButton'
import PresentationButton from '../../CTA/PresentationButton'
import {useTranslation} from 'react-i18next'

const CallToAction = () => {
    const {t} = useTranslation()

    return (
        <footer className="call-to-action">
            <div className="container">
                <div className="title is-size-2 is-size-3-mobile has-text-centered">{t('call-to-action_header')}</div>
                <div className="buttons call-to-action__buttons">
                    <PresentationButton />
                    <RegisterButton />
                </div>
            </div>
        </footer>
    )
}

export default CallToAction
